export default __webpack_public_path__ + "static/media/billing-overall.11f02f4b.svg";